export default __webpack_public_path__ + "media/images/react_icons/filled_wheelchair-5bd97432012e7cf7390b0a373087ef37.svg";